








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AppNavigation extends Vue {
	@Prop({ required: true }) text?: string
}
